export const MAXFILESIZE = 3 * 1024 * 1024;